// CSS
import { fileDownload } from 'Admin/Component/AdFunc'
import { useState } from 'react'
import '_Asset/css/User/Page/UiComponent/dropdown.css'

const Select = () => {

  return (
    <div className="componentBox inputs">
      <div className="pageTit">
        <h2>Dropdowns <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>Components: <span>Select Box, Calendar(Date picker)</span></p>
      </div> 

      {/* Use Way */}
      <div className="useWay">
        <h2>How to use the Select Box kit</h2>
				<p>Click dropdowns to copy and paste where you want to use it.</p>
        <p>Bagic Class: <span>select</span></p>
        <p>Ex. class="<span>select md line_bg type_1</span>"</p>
      </div>

      {/* Select Styles Types */}
      {selectArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>Select Box를 클릭하여 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.selectList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <label htmlFor="">label</label>
                
                <div className="field">
                  <select className={`select ${item.size} ${item.round} ${item.shape} ${item.type}`}>
                    <option value="0">선택</option>
                    <option value="1">사과</option>
                    <option value="2">토마토</option>
                    <option value="3">파인애플</option>
                  </select>
                </div>
                {/* <div className="field">
                  {item.custom ? 
                    <div className="selectBox round_10" onClick={() => setIsActiveBox(!isActiveBox)}>
                      <ul className="selectHeader">
                        <li>선택<i className="icofont-rounded-down"></i></li>
                      </ul>

                      <ul className={`selectBody ${isActiveBox ? 'active' : ''}`}>
                        <li>사과</li>
                        <li>토마토</li>
                        <li>파인애플</li>
                      </ul>
                    </div>
                    :
                    <select type="text" className={`select ${item.round} ${item.shape} ${item.type}`}>
                      <option value="0">선택</option>
                      <option value="1">사과</option>
                      <option value="2">토마토</option>
                      <option value="3">파인애플</option>
                    </select>
                  }
                </div> */}
                <h2 className="fieldTxt">{item.text}</h2>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const selectArr = [
  {
    name: 'Select Box Types',
    class: 'Class: [select sm type_1 / line, line_bg, line_none]',
    selectList: [
      { type: 'type_1', size: 'md', round: 'round_10', shape: '', text: 'Default'},
      { type: 'type_1', size: 'md', round: '', shape: 'line', text: 'Line'},
      { type: 'type_1', size: 'md', round: '', shape: 'line_bg', text: 'Line and background'},
      { type: 'type_1', size: 'md', round: 'round_10', shape: 'line_none', text: 'None line'},
    ]
  },
  {
    name: 'Select Box Arrow Types',
    class: 'Class: [select sm / type_1, type_1_line]',
    selectList: [
      { type: 'type_1', size: 'md', round: 'round_10', shape: '', text: 'Arrow type 1'},
      { type: 'type_1_line', size: 'md', round: 'round_10', shape: '', text: 'Arrow type 1 - line'},
      { type: 'type_2', size: 'md', round: 'round_10', shape: '', text: 'Arrow type 2'},
      { type: 'type_2_line', size: 'md', round: 'round_10', shape: '', text: 'Arrow type 2 - line'},
    ]
  },
  // {
  //   name: 'Custom Div Select Box',
  //   class: 'Class: [selectBox / type_1]',
  //   selectList: [
  //     { custom: true, type: 'type_1', text: 'Custom Type 1'},
  //   ]
  // },
]

export default Select;